/**
 * string の時だけ number に変換
 */
const stringToNumber = (value: string | undefined): number | undefined => {
  return typeof value === "string" ? Number(value) : value;
};

export default stringToNumber;
